module.exports = __webpack_public_path__ + "static/media/ACS Research Spotlight.e2b57440.csv";